import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { StateOption } from "../../../constants/state";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useStyles } from "./StateDropDown.style";

interface IStateDropDownProps {
  options: StateOption[];
  value?: string;
  onSelectState: (state: StateOption) => void;
}

const StateDropDown: FC<
  IStateDropDownProps & Omit<HTMLAttributes<HTMLDivElement>, "onSelect">
> = (props) => {
  const classes = useStyles();
  const { options, value, onSelectState, className, ...otherProps } = props;

  return (
    <div
      role="listbox"
      {...otherProps}
      className={clsx(classes.container, className)}
    >
      {options.map((state, idx) => (
        <div
          className={clsx(classes.option, {
            [classes.selected]: value === state.value,
          })}
          data-gamepad={`state-${idx}`}
          data-selected-class={classes.selected}
          data-native-scroll
          role="option"
          tabIndex={-1}
          aria-selected={value === state.value}
          onClick={() => onSelectState(state)}
          key={state.value}
        >
          <Typography variant={TypographyVariant.BodyB5Medium}>
            {state.label}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default StateDropDown;
